export const TrackingPrefixes = {
  TemplateSelector: 'template-selector',
  InvoiceSelector: 'invoice-selector',
  SendInThread: 'send-in-thread',
};
